import { priceListRules } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';

export const priceListRulesErrorsDetection = (errorMessage: string) => {
  return priceListRules[errorMessage];
};
